import { render, staticRenderFns } from "./staffLeaveAction.vue?vue&type=template&id=1ed3eb48&scoped=true"
import script from "./staffLeaveAction.vue?vue&type=script&lang=js"
export * from "./staffLeaveAction.vue?vue&type=script&lang=js"
import style0 from "./staffLeaveAction.vue?vue&type=style&index=0&id=1ed3eb48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed3eb48",
  null
  
)

export default component.exports